import { Col, Row, Typography } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import i18n from '../../../../i18n';
import message from '../../../../utils/message';
import useNeedAuth from '../../../AuthorizePanel/hooks';
import { refundOrder } from '../../api';
import { PrinterOutlined, ReloadOutlined } from '@ant-design/icons';
import TransparentOverlay from '../../../components/TransparentOverlay';
import { usePrintOrder } from '~/App/hooks';
import { useCheckPermission } from '~/store/permission';
const { Text } = Typography;

const BottomBar = ({ id }: { id?: string }) => {
  const needAuth = useNeedAuth();
  const navigate = useNavigate();
  const { printOrderHistoryDetailReceipt } = usePrintOrder();
  const checkPermission = useCheckPermission();

  const canPrint = checkPermission('orderReceiptPrint:r');

  const onRefund = () => {
    if (!id) return;
    needAuth({
      permissionName: 'orderRefundAuthorization:r',
      entityId: id,
      onSubmit: ({ actionToken }) => {
        refundOrder({ orderId: id, actionToken }).then(({ error }) => {
          if (error) {
            message.error(error);
            return;
          }
          message.warning('Order berhasil direfund');
          navigate('/order/history', { replace: true });
        });
      },
    });
  };

  const onPrint = async () => {
    if (!id || !canPrint) return;
    await printOrderHistoryDetailReceipt(id);
  };

  return (
    <Row className="cart-bottom-bar-row">
      <TransparentOverlay show={!id} />
      {canPrint ? (
        <Col span={12} className="cart-bottom-bar-button" onClick={onPrint}>
          <PrinterOutlined />
          <Text>{i18n.t('cart_print')}</Text>
        </Col>
      ) : null}
      <Col span={12} className="cart-bottom-bar-button" onClick={onRefund}>
        <ReloadOutlined />
        <Text>Refund</Text>
      </Col>
    </Row>
  );
};

export default BottomBar;
